import { datadogLogs } from '@datadog/browser-logs';
import { isAxiosError } from 'axios';

import { getErrorMessage } from '@/utils/errorUtil';

import { camelWorkspacePath, camelWorkspaceScope } from '../apiScope';

export const seriesCatalogQueryKey = (workspaceUuid: string) =>
  [...camelWorkspaceScope(workspaceUuid), 'custom-events', 'series'] as const;

export const patientCustomEventsQueryKey = (workspaceUuid: string, patientUuid: string) =>
  [...camelWorkspaceScope(workspaceUuid), 'patients', patientUuid, 'custom-events'] as const;

export const setEventFieldMutationKey = (workspaceUuid: string, patientUuid: string) =>
  [...patientCustomEventsQueryKey(workspaceUuid, patientUuid), 'set-field'] as const;

export const customEventsBasePath = (workspaceUuid: string, patientUuid: string) =>
  camelWorkspacePath(workspaceUuid, 'patients', patientUuid, 'custom-events');

export const logCustomEventsError = (
  errorKey: string,
  context: Record<string, unknown>,
  error: unknown,
) => {
  datadogLogs?.logger?.error(errorKey, {
    ...context,
    status: isAxiosError(error) ? error.response?.status : undefined,
    error_message: getErrorMessage(error),
  });
};
